import React from 'react';
import DashboardLayout from '../../components/DashboardLayout';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../../components/ui/tabs';
import { CheckSquare, History } from 'lucide-react';
import { TodayRegister, PastDays } from '../../components/AttendanceRegister';

const Attendance = () => (
    <DashboardLayout>
        <div className="space-y-6" data-testid="attendance-page">
            <div>
                <h1 className="text-2xl font-bold text-[#1F2937] font-['Outfit'] flex items-center gap-2"><CheckSquare className="h-6 w-6 text-[#064E3B]" />Attendance</h1>
                <p className="text-[#4B5563]">Take today's register or review and correct past study days</p>
            </div>
            <Tabs defaultValue="today">
                <TabsList><TabsTrigger value="today" data-testid="att-tab-today"><CheckSquare className="h-4 w-4 mr-1" />Today</TabsTrigger><TabsTrigger value="past" data-testid="att-tab-past"><History className="h-4 w-4 mr-1" />Past days</TabsTrigger></TabsList>
                <TabsContent value="today"><TodayRegister /></TabsContent>
                <TabsContent value="past"><PastDays /></TabsContent>
            </Tabs>
        </div>
    </DashboardLayout>
);

export default Attendance;
